import { z } from "zod";
import { UserSchema } from "../../../models/user/user";
import { Seniority } from "../../../types/types";

export const getAllContractsSchema = z.array(z.object({
    id: z.number(),
    billing_objective: z.string(),
    das: z.number(),
    end_date: z.string().nullable(),
    gross_yearly_salary: z.string(),
    management_share: z.string(),
    office: z.string(),
    presence: z.string(),
    production_objective: z.string(),
    production_share: z.string(),
    ressource: UserSchema,
    sales_objective: z.string(),
    seniority: z.nativeEnum(Seniority),
    start_date: z.string(),
    support_share: z.string(),
    yearly_salary: z.string()
}))

export type GetAllContractsSchemaType = z.infer<typeof getAllContractsSchema>;